import { HTTP } from "./common"

import {GET_MAILING_TEMPLATES, SEND_MAIL} from "@/store/types/index"

export const Mailing = {
  [GET_MAILING_TEMPLATES] () {
    let urlString = `mailing`
    return HTTP.get(urlString)
      .then(response => {
        return response.data
      })
  },
  [SEND_MAIL] (data) {
    let urlString = 'mailing/sendmail/'
    return HTTP.post(urlString, data)
      .then(response => {
        return response.data
      })
  }
}
